import { Injectable } from '@angular/core';
import {MatSnackBar, MatSnackBarRef} from "@angular/material/snack-bar";
import {CustomSnackbarComponent} from "../../shared/custom-snackbar/custom-snackbar.component";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private readonly matSnackBar: MatSnackBar) {}

  openSuccessMessage(message: string): MatSnackBarRef<CustomSnackbarComponent> {
    return this.matSnackBar.openFromComponent<CustomSnackbarComponent>(CustomSnackbarComponent, {
      data: {
        message,
        icon: 'done',
      },
      duration: 5000,
      panelClass: 'custom-snackbar-success',
    });
  }

  openErrorMessage(errorMessage: string): MatSnackBarRef<CustomSnackbarComponent> {
    return this.matSnackBar.openFromComponent<CustomSnackbarComponent>(CustomSnackbarComponent, {
      data: {
        message: errorMessage,
        icon: 'close',
      },
      duration: 5000,
      panelClass: 'custom-snackbar-error',
    });
  }
}
